import { sendTypify } from "../../helpers/fetching";

export default {
  state: {
    option: false,
    loading: false,
    error: null,
    response: {},
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setResponse(state, data) {
      state.response = data;
    },
    setTypify(state, data) {
      console.log(data);
      state.option = data;
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    setTypify({ commit }, value) {
      commit("clearError");
      commit("setTypify", value);
    },
    toTypify({ commit }, value) {
      console.log(value);
      commit("clearError");
      commit("setLoading", true);
      sendTypify(value)
        .then((response) => {
          commit("setResponse", response);
        })
        .catch((error) => {
          console.error(error);
          commit("setError", error);
        });
    },
  },
};
